/**
 * Empty stub for @amzn/retail-i18n-price-format-config
 *
 * AT2SignInUI does not use price formatting. This stub replaces the massive
 * (~5.68MB) price format configuration data that was being bundled via the
 * transitive dependency chain:
 *
 *   @amzn/aws-tc-xb-root-utils
 *     -> @amzn/i18n.localization-context
 *       -> @amzn/i18n.marketplace-defaults
 *         -> @amzn/i18n.acsoffline-i18n-configuration-provider-typescript
 *           -> @amzn/retail-i18n-price-format-config  (THIS PACKAGE)
 *
 * The resolver expects three JSON files with specific exports:
 *   - documents.json  -> { documents: [...] }
 *   - queries.json    -> { queries: [...] }
 *   - hierarchical_queries.json -> { queries: [...] }
 *
 * This stub provides empty arrays for all three, which means any price format
 * resolution call would return empty/null results. Since the sign-in page never
 * calls price formatting, this is safe.
 */
module.exports = {
  documents: [],
  queries: [],
};
